import { api } from '@/utils/api'

import { ApiResponseHandler, Gettable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

export namespace ApiTaRe170 {
  // GET parameters
  export namespace Get {

    export interface Request {
      query: {
        monthlyCheckId: string
      }
    }

    export type Response = {
      informationPdfUrl: string
    }
  }

  // API Path
  const path: string = '/ta/monthlyCheck/pdf'

  // API本体
  export class Api extends ApiBase implements Gettable<Get.Request, Get.Response, ResponseError> {
    public get<R>(params: Get.Request,
      successHandler: ApiResponseHandler<Get.Response, R>,
      errorHandler: ApiResponseHandler<ResponseError, R>)
      : Promise<R | null> {

        // 成功時のレスポンス構造サンプル
        const validationSample: Get.Response = {
          informationPdfUrl: ''
        }

        // エラー時のレスポンス構造サンプル
        const validationErrorSample: ResponseError = {
          error: {
            messageId: '',
            message: ''
          }
        }

        // API呼び出し
        return this.callbackWrapper<Get.Response, ResponseError, R>(
          api.get<Get.Response>(path, { params: params.query }),
          successHandler,
          errorHandler,
          validationSample,
          validationErrorSample
        )
      }
  }
}